import React, { Fragment, useState } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import RHService from '../../../../../services/rh-auth';



const Estagiarios = () => {
    const [nome, setNome] = useState("");
    const [funcao, setFuncao] = useState("");
    const [secretaria, setSecretaria] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const local = await RHService.cadastroEstagiario({
                nome: nome,
                funcao: funcao,
                secretaria: secretaria
            })
            if (local.data["_id"]) {
                alert("estagiario cadastrado com sucesso!")
                setSucesso(true);
            }
            else {
                alert(local.data["error"]);
            }
        } catch (error) {
            console.log(error)
        }
    }


    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setNome("");
        setFuncao("");
        setSecretaria("");
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Estagiário"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="funcao">
                                <FloatingLabel
                                    label="Função Desempenhada"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="funcao"
                                        value={funcao}
                                        onChange={e => setFuncao(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="Secretaria">
                                <FloatingLabel
                                    label="Secretaria"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Secretaria"
                                        name="secretaria"
                                        onChange={e => setSecretaria(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="Secretaria Municipal de Segurança Pública, Administração e Mobilidade Urbana">Segurança Pública, Administração e Mobilidade Urbana</option>
                                        <option value="Secretaria Municipal de Agricultura, Pecuária, Abastecimento e Aquicultura">Agricultura, Pecuária, Abastecimento e Aquicultura</option>
                                        <option value="Secretaria Municipal de Educação">Educação</option>
                                        <option value="Secretaria Municipal de Esporte, Lazer, Turismo e Cultura">Esporte, Lazer, Turismo e Cultura</option>
                                        <option value="Secretaria Municipal de Fazenda, Planejamento, Orçamento, Indústria e Comércio">Fazenda, Planejamento, Orçamento, Indústria e Comércio</option>
                                        <option value="Secretaria Municipal de Gabinete e Comunicação">Gabinete e Comunicação</option>
                                        <option value="Secretaria Municipal de Controle Interno">Controle Interno</option>
                                        <option value="Secretaria Municipal de Governo e Gestão">Governo e Gestão</option>
                                        <option value="Secretaria Municipal de Meio Ambiente, Urbanismo e Defesa Civil">Meio Ambiente, Urbanismo e Defesa Civil</option>
                                        <option value="Secretaria Municipal de Obras e Serviços Públicos">Obras e Serviços Públicos</option>
                                        <option value="Secretaria Municipal de Saúde e Prevenção à Dependência Química">Saúde e Prevenção à Dependência Química</option>
                                        <option value="Secretaria Municipal de Desenvolvimento Social e Direitos Humanos">Desenvolvimento Social e Direitos Humanos</option>
                                        <option value="Secretaria Municipal de Trabalho, Envelhecimento Saudável e da Juventude">Trabalho, Envelhecimento Saudável e da Juventude</option>
                                        <option value="Secretaria Municipal de Turismo">Turismo</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/rh/estagiario'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Estagiário cadastrado com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outro
                </Button>
                <br /><br />
                <Link to={'/restrito/rh/estagiario/listar'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Estagiarios
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/rh/estagiario'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Estagiarios;